<div class="row">
  <div class="col-3">
  </div>
  <div class="col pl-3">
    <div class="row">
      <div class="col">
        <!-- <h6 [attr.id]="'subjecttitle'+subject.code">{{ subject.title }}</h6> -->
        <div class="row my-3 align-items-center">
          <div class="col-4 pr-4">
          </div>
          <div class="col-8" *ngIf="allLearningObjectives">
            <div *ngFor="let subLearningObjective of allLearningObjectives; trackBy: idLearningObjective"
                 [class.active]="selectedLearningObjective && subLearningObjective.id === selectedLearningObjective.id"
                 [attr.id]="'categories-' + subLearningObjective.id"
                 [style.margin-left]="'20px'"
                 class="list-group-item p-0 d-flex">
              <div class="align-self-center text-muted flex-shrink-1 pl-3 border-0">
                <input type="checkbox"
                       class="checklo"
                       [disabled]="!editMode"
                       [ngModel]="subLearningObjective.inList"
                       (change)="toggleLearningObjectiveHandler(subLearningObjective)" />
              </div>
              <app-learning-objective-view class="flex-grow-1 p-1"
                                           [class.c-pointer]="subLearningObjective.inList"
                                           [class.clickable]="subLearningObjective.inList"
                                           (click)="select(subLearningObjective)"
                                           [class.text-muted]="!subLearningObjective.inList"
                                           [learningObjective]="subLearningObjective">
              </app-learning-objective-view>
            </div>
          </div>
          <!-- <div class="">
            <div [attr.id]="'categories-' + learningObjective.id"
                 [class.active]="selectedLearningObjective && learningObjective.id === selectedLearningObjective.id"
                 class="list-group-item p-0 d-flex border-0 m-1">
              <div class="p-3 d-flex align-items-center">
                <div class="toggle-button toggle-button--tuuli">
                  <input type="checkbox"
                         [id]="learningObjective.id"
                         [disabled]="!editMode"
                         [ngModel]="learningObjective.inList"
                         (change)="toggleLearningObjectiveHandler(learningObjective)" />

                  <label [for]="learningObjective.id"
                         class="m-0"></label>
                  <div class="toggle-button__icon"></div>
                </div>

              </div>
              <app-learning-objective-view class="flex-grow-1 p-1"
                                           [class.c-pointer]="learningObjective.inList"
                                           [class.clickable]="learningObjective.inList"
                                           (click)="select(learningObjective)"
                                           [class.text-muted]="!learningObjective.inList"
                                           [learningObjective]="learningObjective">
              </app-learning-objective-view>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- [class.text-muted]="learningObjective.inList"
[class.font-italic]="learningObjective.inList" -->
